<template>
  <UIDrawer
    :title
    :is-open
    :z-index
    :allow-tray
    @minimize="handleMinimize"
    @close="handleClose"
  >
    <CashflowProjectionForm :instance="modal.entity" with-position @close="handleClose" />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { CashFlowProjectionClass } from '..'
import { ModalClass } from '@types'

import { CASHFLOW_PROJECTION_MODAL_TITLE, CASHFLOW_PROJECTION_MODAL_TITLE_NEW } from './utils/const'

import { UIDrawer } from '@ui/modals'
import CashflowProjectionForm from './CashflowProjectionForm.vue'

type Props = {
  modal: ModalClass<CashFlowProjectionClass>
}

const props = defineProps<Props>()

const title = computed(() =>
  props.modal.entity.isNew ? CASHFLOW_PROJECTION_MODAL_TITLE_NEW : CASHFLOW_PROJECTION_MODAL_TITLE,
)

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)
const allowTray = computed(() => props.modal.allowTray)

const handleMinimize = () => {
  props.modal.hide()
}

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
